<template>
  <div class="dutch-auction-stats">
    <h3 class="title">
      <img v-if="props.decoration === 'alert'" src="@/images/siren.svg" class="siren" />
      <span>{{ props.title }}</span>
      <img v-if="props.decoration === 'alert'" src="@/images/siren.svg" class="siren reverse" />
    </h3>

    <div class="countdown">
      <div v-for="{ number, label } in timeBlocks" :key="label" class="time-block">
        <div class="time-block_num">
          {{ number.value }}
        </div>
        <div class="time-block_label">{{ label }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, toRef } from 'vue';
import useCountdown from '/src/utility/useCountdown'

let props = defineProps({
  title: { type: String, default: 'Next Price Decrease' },
  decoration: { type: String },
  auctionInterval: { type: Number, default: 2 * 60 * 60 * 1000 },
  endDate: {
    type: Date, default: () => {
      let date = new Date()
      date.setTime(date.getTime() + .5 * 60 * 60 * 1000)
      return date
    }
  },
})

let { days, hours, minutes, seconds } = useCountdown({ endDate: toRef(props, 'endDate') })
let timeBlocks = computed(() => {
  let blocks = [
    { number: days, label: 'Days' },
    { number: hours, label: 'Hours' },
    { number: minutes, label: 'Mins' },
    { number: seconds, label: 'Secs' },
  ]
  let blocksHiddenIndex = -1
  for (let [i, { number }] of blocks.entries()) {
    if (number?.value <= 0) {
      blocksHiddenIndex = i
    } else {
      break
    }
  }
  let displayBlocks = blocks.slice(blocksHiddenIndex + 1)
  return displayBlocks.length === 0 ? [
    { number: ref('00'), label: 'Secs' },
  ] : displayBlocks
})
</script>

<style lang="scss" scoped>
@import "../../../assets/style/mixins.scss";

.dutch-auction-stats {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: DM Sans;
  font-style: normal;

  @include mediaOnlyScreenMax(500px) {
    .title {
        margin-right: -24px;
        margin-left: -46px;
      }
  }
}

.title {
  font-size: 2.42em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.countdown {
  display: flex;
  text-transform: uppercase;

  > * + * {
    margin-left: 24px;
  }
}

.time-block {
  display: flex;
  align-items: center;
}
.time-block_num {
  font-family: DM Mono;
  font-size: 3.21em;
  min-width: 2ch;
  text-align: center;
  display: flex;

  span {
    min-width: 1ch;
    text-align: right;
  }
  span + span {
    text-align: left;
  }
}
.time-block_label {
  font-size: 1.57em;
}

.price-block {
  display: flex;
  flex-direction: column;
  align-items: center;

  text-transform: uppercase;
}
.price {
  font-size: 1.42em;
}
.price-label {
  font-size: 0.9em;
  opacity: .5;
}

.time-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.siren {
  width: 52px;
  transform: rotateZ(-20deg) scaleX(-1);
  margin-right: 36px;
}
.reverse {
  transform: rotateZ(20deg);
  margin-right: 0;
  margin-left: 36px;
}
</style>
